import { Icon } from '@/lib/icons';
import { cn } from '@/lib/utils';

interface StarRatingProps {
  value: number | null;
  onChange: (v: number) => void;
  label: string;
}

export function StarRating({ value, onChange, label }: StarRatingProps) {
  return (
    <div className="space-y-2">
      <label className="text-[0.64rem] font-semibold uppercase tracking-[0.22em] text-muted-foreground/50">{label}</label>
      <div className="flex gap-2">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => onChange(star)}
            className={cn(
              'transition-colors',
              value && star <= value ? 'text-brand' : 'text-muted-foreground/30',
            )}
          >
            <Icon name="star" className="h-7 w-7" />
          </button>
        ))}
        {value && <span className="ml-2 text-lg font-semibold text-foreground">{value}/5</span>}
      </div>
    </div>
  );
}
